import {Nav} from "react-bootstrap";
import {NavLink, Outlet} from "react-router";

// Inside SiteLayout, behind RequireAuth and RequireAdmin.
export function AdminLayout() {
    return (
        <>
            <Nav variant="underline" className="mb-4">
                <Nav.Item><Nav.Link as={NavLink} to="/admin/users">Users</Nav.Link></Nav.Item>
                <Nav.Item><Nav.Link as={NavLink} to="/admin/licenses">TSA-1 licences</Nav.Link></Nav.Item>
            </Nav>
            <Outlet/>
        </>
    );
}
